module.exports = "pegasus/assets/styleGroup1-google.gif";